import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
// import {
//   Search as SearchIcon,
//   DoubleArrow as DoubleArrowIcon,
//   CheckCircle as CheckCircleIcon
// } from '@material-ui/icons';
import { joinClasses, callService } from 'utils/utility';
import { errorAlert, warningAlert } from 'utils/alert';
import { calvh, clickAnime } from 'utils/element';
import { getStudentGameComment } from 'services/student-game-comment';
import { useImagesContext } from 'contexts/ImagesContext';
import Comment from 'components/fragments/Comment';
import ButtonBack from 'components/fragments/ButtonBack';
import Progress from 'components/fragments/Progress';
import { Carousel } from 'antd';
//import { useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    height: '100%',
    width: '100%',
  },
  'carousel-container': {
    zIndex: 1,
    width: '100%',
    height: 'auto',
    '& [class~="ant-carousel"] [class~="slick-dots"] button': {
      background: '#9798aa !important',
    },
    '& [class~="ant-carousel"] [class~="slick-dots"] [class~="slick-active"] button':
      {
        background: '#adaeb6 !important',
      },
    '& [class~="ant-carousel"] [class~="slick-dots"]': {
      display: 'none !important',
    },
  },
  'student-game-comment-comment': {
    maxHeight: calvh('3.5vh'),
    '@media (min-width:434px)': {
      //maxHeight: calvh('5vh'),
    },
    '@media (max-width:350px)': {
      //maxHeight: calvh('4vh'),
    },
    objectFit: 'contain',
  },
  'label-date': {
    fontSize: calvh('3.8vh'),
    lineHeight: calvh('3.8vh'),
    color: '#000',
    textShadow: `#fff ${calvh('0.1vh')} ${calvh('0.1vh')} 0px, #fff ${calvh(
      '-0.1vh'
    )} ${calvh('0.16vh')} 0px, #fff 0px ${calvh('-0.16vh')} 0px, #000 ${calvh(
      '0.1vh'
    )} ${calvh('0.1vh')} 0px`,
    //paddingBottom: '5px',
  },
  'label-by': {
    fontSize: calvh('4vh'),
    lineHeight: calvh('4vh'),
    color: '#000',
    textShadow: `#fff ${calvh('0.1vh')} ${calvh('0.1vh')} 0px, #fff ${calvh(
      '-0.1vh'
    )} ${calvh('0.16vh')} 0px, #fff 0px ${calvh('-0.16vh')} 0px, #000 ${calvh(
      '0.1vh'
    )} ${calvh('0.1vh')} 0px`,
    alignSelf: 'flex-end',
  },
  'container-devider': {
    width: '100%',
    height: '.2rem',
    backgroundColor: '#7d4c08',
  },
  'student-game-comment-prev': {
    position: 'fixed',
    zIndex: 2,
    left: '91vw',
    top: calvh('9vh'),

    height: calvh('8vh'),
    maxWidth: '8vw',
    objectFit: 'contain',
    objectPosition: '0% 0%',
  },
  'student-game-comment-next': {
    position: 'fixed',
    zIndex: 2,
    left: '91vw',
    bottom: calvh('3vh'),

    height: calvh('8vh'),
    maxWidth: '8vw',
    objectFit: 'contain',
    objectPosition: '0% 0%',
  },
  'img-watch': {
    height: calvh('8vh'),
    maxWidth: '12vw',
    objectFit: 'contain',
    margin: 4,
  },
}));

const DEFAULT_COMMENT_PAGE = 0;
const DEFAULT_COMMENT_ROWS_PER_PAGE = 4;

const StudentGameComment = (props) => {
  const { images } = useImagesContext();
  const c = joinClasses(useStyles({ ...props }));
  const [getStudentGameCommentFlag, setGetStudentGameCommentFlag] =
    React.useState({});
  const [studentGameComments, setStudentGameComments] = React.useState([]);
  const [commentPagination, setCommentPagination] = React.useState({
    rowsPerPage: DEFAULT_COMMENT_ROWS_PER_PAGE,
    page: DEFAULT_COMMENT_PAGE,
  });
  const refCommentCarousel = React.useRef(null);

  React.useEffect(() => {
    handleGetStudentGameComment();
  }, []);

  const handleCommentCarouselAfterChangePage = (newPage) => {};

  const handleClickCommentPrev = () => {
    refCommentCarousel.current && refCommentCarousel.current.prev();
    if (commentPagination?.page > 0) {
      setCommentPagination((prev) => ({ ...prev, page: prev.page - 1 }));
    } else {
      setCommentPagination((prev) => ({
        ...prev,
        page:
          Math.ceil(
            (studentGameComments || []).length / DEFAULT_COMMENT_ROWS_PER_PAGE
          ) - 1,
      }));
    }
  };

  const handleClickCommentNext = () => {
    refCommentCarousel.current && refCommentCarousel.current.next();
    if (
      commentPagination?.page <
      Math.ceil(
        (studentGameComments || []).length / DEFAULT_COMMENT_ROWS_PER_PAGE
      ) -
        1
    ) {
      setCommentPagination((prev) => ({ ...prev, page: prev.page + 1 }));
    } else {
      setCommentPagination((prev) => ({ ...prev, page: 0 }));
    }
  };

  const handleGetStudentGameComment = (next) => {
    callService(
      getStudentGameComment,
      {},
      setGetStudentGameCommentFlag,
      (resp) => {
        setStudentGameComments(resp);
        next && next(resp);
      },
      (error) => {
        errorAlert(error);
      }
    );
  };

  const pendingFlag = React.useMemo(
    () => getStudentGameCommentFlag.request,
    [getStudentGameCommentFlag.request]
  );

  const successFlag = React.useMemo(
    () => getStudentGameCommentFlag.success,
    [getStudentGameCommentFlag.success]
  );

  return (
    <div className={c('root')}>
      <Grid
        container
        direction='column'
        justifyContent='space-between'
        alignItems='center'
        style={{ height: '100%' }}
      >
        <Grid
          item
          container
          justifyContent='center'
          alignItems='flex-start'
          alignContent='flex-start'
          style={{ marginTop: '0.5rem' }}
        >
          {pendingFlag ? (
            <Progress />
          ) : successFlag ? (
            <>
              <Grid item xs={11} container>
                <img
                  style={{
                    height: calvh('4vh'),
                    maxWidth: '42vw',
                    objectFit: 'contain',
                  }}
                  src={images[`student-game-comment-comment.png`]}
                />
                <Grid
                  item
                  xs={12}
                  container
                  justifyContent='center'
                  style={{ padding: '5px 0px' }}
                >
                  <div className={c('container-devider')} />
                </Grid>
              </Grid>
              <Grid
                item
                xs={11}
                container
                style={{
                  // height: calvh('79vh'),
                  // overflow: 'hidden',
                  position: 'relative',
                }}
              >
                <div className={c('carousel-container')}>
                  <Carousel
                    afterChange={handleCommentCarouselAfterChangePage}
                    ref={refCommentCarousel}
                    dotPosition='right'
                  >
                    {Array.from(
                      Array(
                        Math.ceil(
                          (studentGameComments || []).length /
                            DEFAULT_COMMENT_ROWS_PER_PAGE
                        )
                      ).keys()
                    ).map((_, pidx) => {
                      const page = pidx;
                      const pageSize = commentPagination.rowsPerPage;
                      const trainersFilter = (studentGameComments || []).slice(
                        page * pageSize,
                        page * pageSize + pageSize
                      );
                      return (
                        <div key={`comment-page-` + pidx}>
                          <div
                            style={{
                              height: calvh('79vh'),
                              overflow: 'auto',
                            }}
                          >
                            {(trainersFilter || []).map((comment, idx) => (
                              <div
                                key={'comment_' + idx}
                                style={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  flexFlow: 'column',
                                }}
                              >
                                <div className={c('label-date')}>
                                  {comment.date}
                                </div>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    flexWrap: 'nowrap',
                                  }}
                                >
                                  <img
                                    className={c('img-watch')}
                                    src={
                                      images[`student-game-comment-watch.png`]
                                    }
                                    ref={clickAnime}
                                  />
                                  <Comment
                                    text={comment.comment}
                                    styles={{
                                      root: {
                                        height: '100%',
                                        width: '90%',
                                      },
                                      field: {
                                        //height: calvh('10vh'),
                                      },
                                    }}
                                  />
                                </div>

                                <div className={c('label-by')}>
                                  {comment.byTeacher}
                                </div>
                                <Grid
                                  item
                                  xs={12}
                                  container
                                  justifyContent='center'
                                  style={{ padding: '5px 0px' }}
                                >
                                  <div className={c('container-devider')} />
                                </Grid>
                              </div>
                            ))}
                          </div>
                        </div>
                      );
                    })}
                  </Carousel>
                </div>
                <img
                  className={c('student-game-comment-prev')}
                  src={images['student-game-comment-prev.png']}
                  onClick={handleClickCommentPrev}
                  ref={clickAnime}
                />
                <img
                  className={c('student-game-comment-next')}
                  src={images['student-game-comment-next.png']}
                  onClick={handleClickCommentNext}
                  ref={clickAnime}
                />
              </Grid>
            </>
          ) : null}
        </Grid>
        <div style={{ position: 'absolute', bottom: '-4vh', zIndex: 2 }}>
          <ButtonBack />
        </div>
      </Grid>
    </div>
  );
};

export default StudentGameComment;
